import type { MakeInputProps } from '@frontend/forms';
import type { ClassName } from '@frontend/web-utils';
import { mergeAndConcatClasses, safeCss } from '@frontend/web-utils';
import type { NumberInputProps as MNumberInputProps } from '@mantine/core';
import { NumberInput as MNumberInput } from '@mantine/core';
import { forwardRef } from 'react';
import { InputLabel } from '../InputLabel';

// It must be string | number to account for leading "-" signs
export type NumberInputProps = MakeInputProps<
  MaybeUndefined<number | string>,
  MNumberInputProps,
  'labelProps' | 'type'
> & {
  className?: ClassName;
};

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ className, label, onChange, showOptionalText, ...props }, ref) => {
    const numberInputClassNames = {
      input: safeCss('text-p-md h-[56px] rounded-sm focus-within:border-textPrimary'),
      root: mergeAndConcatClasses(safeCss('gap-y-sm flex flex-col '), className),
    };

    return (
      <MNumberInput
        classNames={numberInputClassNames}
        inputMode="numeric"
        label={label ? <InputLabel label={label} showOptionalText={showOptionalText} /> : null}
        onChange={(event) => {
          onChange(event);
        }}
        ref={ref}
        {...props}
      />
    );
  },
);
